export default {"src":"/_next/static/media/defaultSmallIndustrial.9fe44f4d.svg","height":100,"width":140};